import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LinkTabService {

  constructor() { }

  getTabs(linkId: number, isCsp: boolean): any[] {
    let tabInfo = []
    tabInfo = [
      {
        id: 0,
        text: 'Information',
        icon: 'far fa-info-circle',
      },
      {
        id: 1,
        text: 'Pricing',
        icon: 'far fa-wallet',
      },
      {
        id: 2,
        text: 'Support',
        icon: 'far fa-headset',
      },
    ];

    if (linkId && linkId > 0) {
      tabInfo.push({
        id: 3,
        text: 'Setup',
        icon: 'far fa-cog',
      });
      if (!isCsp) {
        tabInfo.push({
          id: 4,
          text: 'Scheduler',
          icon: 'far fa-calendar',
        });
      }
      if (!isCsp) {
        tabInfo.push({
          id: 5,
          text: 'Logs',
          icon: 'far fa-bars',
        });
        
      }
    }
    return tabInfo;
  }
}

